var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLinked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 36,
  viewBox: "0 0 40 36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.724 24.386H5.032a2.05 2.05 0 0 1-2.05-2.05V5.966a2.982 2.982 0 0 1 2.983-2.983h16.5c1.061 0 1.92.86 1.92 1.92h2.983A4.903 4.903 0 0 0 22.466 0H5.965A5.965 5.965 0 0 0 0 5.965v16.372a5.032 5.032 0 0 0 5.032 5.031h2.692v-2.982Zm10.873-12.982h15.438a2.982 2.982 0 0 1 2.983 2.982v15.439a2.982 2.982 0 0 1-2.983 2.982H18.597a2.982 2.982 0 0 1-2.983-2.982V14.386a2.982 2.982 0 0 1 2.983-2.982Zm-5.965 2.982a5.965 5.965 0 0 1 5.965-5.965h15.438A5.965 5.965 0 0 1 40 14.386v15.439a5.965 5.965 0 0 1-5.965 5.965H18.597a5.965 5.965 0 0 1-5.965-5.965V14.386Z",
  fill: "#00B177"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#00B177",
  strokeWidth: 3,
  strokeLinecap: "round",
  d: "M22.388 23.223 24.605 25l5.593-6"
}))));

export default SvgLinked;